import React from 'react'

function Temoignage() {
  return (
    <div className="temoignage container mt-5">
        <div className="cat-header">
            <h4 className='cat-subtitle'>AVIS</h4>
            <h3 className='cat-title'>ILS TÉMOIGNENT</h3>
        </div>
        <div className="tem-body">
          <div id="carouselExampleDark" className="carousel carousel-dark slide">
              <div className="carousel-inner">
                <div className="carousel-item active" data-bs-interval="10000">
                  <img src="/images/slider.png" className="d-block w-100" alt="..." />
                  <div className="carousel-caption d-none d-md-block">
                    <h5>First slide label</h5>
                    <p>Some representative placeholder content for the first slide.</p>
                  </div>
                </div>
                <div className="carousel-item" data-bs-interval="2000">
                  <img src="/images/slider.png" className="d-block w-100" alt="..." />
                  <div className="carousel-caption d-none d-md-block">
                    <h5>Second slide label</h5>
                    <p>Some representative placeholder content for the second slide.</p>
                  </div>
                </div>
                <div className="carousel-item">
                  <img src="/images/slider.png" className="d-block w-100" alt="..." />
                  <div className="carousel-caption d-none d-md-block">
                    <h5>Third slide label</h5>
                    <p>Some representative placeholder content for the third slide.</p>
                  </div>
                </div>
              </div>
              <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleDark" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
              </button>
              <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleDark" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
              </button>
            </div>
        </div>
    </div>
  )
}

export default Temoignage